import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

export const getPaymentSettingSaga = createAction(
  "GET_PAYMENT_SETTING",
  ({ payload }: SagaActionParams<Type.PaymentSettingDto>) => ({
    payload,
    url: "/api/PaymentSettings/default",
  })
);
export const createPaymentSettingSaga = createAction(
  "CREATE_PAYMENT_SETTING",
  ({ payload, body }: SagaActionParams<Type.PaymentSettingDto>) => ({
    payload,
    url: "/api/PaymentSettings",
    body,
  })
);
export const updatePaymentSettingSaga = createAction(
  "UPDATE_PAYMENT_SETTING",
  ({ payload, id, body }: SagaActionParams<Type.PaymentSettingDto>) => ({
    payload,
    url: "/api/PaymentSettings/" + id,
    body,
  })
);

const paymentSettingsSaga = [
  takeLatest<any>(
    getPaymentSettingSaga.toString(),
    (payload: SagaGenericParams<Type.PaymentSettingDto>) =>
      getSaga<Type.PaymentSettingDto>(payload)
  ),
  takeLatest<any>(
    createPaymentSettingSaga.toString(),
    (payload: SagaGenericParams<Type.PaymentSettingDto>) =>
      postSaga<Type.PaymentSettingDto>(payload)
  ),
  takeLatest<any>(
    updatePaymentSettingSaga.toString(),
    (payload: SagaGenericParams<Type.PaymentSettingDto>) =>
      putSaga<Type.PaymentSettingDto>(payload)
  ),
];

export default paymentSettingsSaga;
